module.exports = __webpack_public_path__ + "static/media/find-icon-on.16a5ea2d.svg";